import { Location, CommonModule, TitleCasePipe } from '@angular/common';
import { Component, OnInit, OnDestroy, AfterViewInit, TemplateRef, ViewChild, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router, RouterModule } from '@angular/router';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { Observable, Subscription } from 'rxjs';
import { BENEFITS_KEY, PricePlanService } from 'src/app/components/Price-subscritions/priceplanService';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { UserService } from 'src/app/services/UserService';
import { ApiService } from 'src/app/services/api.service';
import { ExcelService } from 'src/app/services/excelService';
import { SearchData } from 'src/app/services/searchData';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { AddUserComponent } from '../add-user/add-user.component';
import { BusinessModel } from '../customer-modals/business-modal';
import { CUSTOMER_MENU_ITEMS, CustomerService, TEXT_FIELDS } from '../customer-service.service';
import { AdminHorMenuComponent } from '../admin-hor-menu/admin-hor-menu.component';
import { CommonModalComponent } from '../common-modal/common-modal.component';
import { MtaFilterPipe } from 'src/app/pipe/name-filter.pipe';
import { FormsModule } from '@angular/forms';
import { CompanyDataService } from '../company/company.service';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { APP_ICONS } from 'src/app/icons/icon-provider';

interface CustomModalOptions extends ModalOptions {
  title: any,
  planDetails: any,
  userData: any,
  KEY: any,
  Fields: any
}
export const MODAL_OPTIONS: any = {
  keyboard: false,
  backdrop: true,
  class: 'modal-lg',
  ignoreBackdropClick: true,
};
interface CustomUserModalOptions extends ModalOptions {
  title: any,
  keyboard: boolean,
  backdrop: boolean,
  class: string,
  ignoreBackdropClick: boolean,
}
@Component({
  selector: 'app-customer-detail',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatTabsModule,
AdminHorMenuComponent,
    CommonModalComponent,
    MtaFilterPipe,
    FormsModule,
    TitleCasePipe
  ,
    NgIconComponent,
  ],
  providers: [provideIcons(APP_ICONS)],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './customer-detail.component.html',
  styleUrls: ['./customer-detail.component.scss', '../../../../../styles/admin/style.scss', '../../../../../styles/admin/app.scss']
})
export class CustomerDetailComponent implements OnInit, OnDestroy, AfterViewInit {
  userType = localStorage.getItem('userType');
  // User info for display when no business exists
  userGigsumoId: string = localStorage.getItem('GSSID') || '';
  userPlan: string = localStorage.getItem('MemberShipType') || 'Free';
  private userId: string = localStorage.getItem('userId') || '';
  // Sidebar toggle state - persisted in localStorage
  sidebarExpanded: boolean = localStorage.getItem('customerDetailSidebarExpanded') !== 'false';
  // Skip CSS transitions on initial render to prevent sidebar flash during route changes
  skipTransition: boolean = true;

  selectedItem: CUSTOMER_MENU_ITEMS = "plan";
  selectedName !: string;
  showModal: boolean = false;

  openbusinessModal:boolean=false;
  USERID: string;
  placeHolderText: string = "Search by name (or) email";
  filterData  : any = {};
  filterContext : any = [];
  // Full admin panel menu items (Business Jobs, Candidates, Applicants moved to standalone modules)
  // Company menu hidden - moved to Contract Center module
  fullNavBarList: Array<any> = [
    // Company Menu - Simple menu item (sub-menu shown horizontally at top)
    {
      item: "company",
      name: "Company",
      path: '/user-management/company/profile',
      activeRoutes: [
        '/user-management/company',
        '/user-management/company/profile',
        '/user-management/company/services',
        '/user-management/company/portfolio',
        '/user-management/company/contact-persons',
        '/user-management/company/financials'
        // Commented out - moved to Contract Center module
        // '/user-management/company/customer-docs',
        // '/user-management/company/supplier-docs',
        // '/user-management/company/agreements'
      ]
    },
    {
      item: "plan",
      name: "Plan Master",
      path: '/user-management/plan',
      // All child routes that should highlight Plan Master
      activeRoutes: [
        '/user-management/plan',
        '/user-management/user',
        '/user-management/interaction',
        '/user-management/jobs',
        '/user-management/workSpace',
        '/user-management/contacts',
        '/user-management/network',
        '/user-management/businessContacts',
        '/user-management/businessNetworks',
        // Publish Settings is the last tab in admin-hor-menu's navBarList and
        // belongs to the same Plan Master group as the rest. It was the only
        // tab missing here, so landing on it left the whole sidebar unhighlighted
        // (no other menu item's path prefix-matches this route either).
        '/user-management/publishSettings'
      ]
    },
    {
      item: "billing",
      name: "Billing",
      path: '/user-management/billing'
    },
    {
      item: "settings",
      name: "Security Settings",
      path: '/user-management/settings'
    },
    {
      item: "notification",
      name: "Notifications",
      path: '/user-management/notiSettings'
    },
    {
      item: "referral",
      name: "Referrals",
      path: '/user-management/referral'
    },
    {
      item: "credit",
      name: "Credits",
      path: '/user-management/credit'
    },
    {
      item: "appAccess",
      name: "App Access",
      path: '/user-management/appAccess'
    },
  ];

  // Standalone Job Center / Talent Center / Applicants menu items
  standaloneNavBarList: Array<any> = [
    {
      item: "businessJob",
      name: "Job Center",
      path: '/job-center'
    },
    {
      item: "businessCandidate",
      name: "Talent Center",
      path: '/talent-center'
    },
    {
      item: "businessApplicants",
      name: "Talent Pools",
      path: '/talent-pools'
    }
  ];

  // Active navbar list - determined by route context
  navBarList: Array<any> = [];
  commondata: any = {};
  clickEventsubscription: Subscription;
  businessData: BusinessModel;
  manageButton: string;
  // Bag for the constructor router/data subscriptions so they are torn down
  // on destroy instead of leaking a live listener per screen visit.
  private subscriptions = new Subscription();
  userData: any[];
  tempUserData: any;
  role:any;
  MemberShipType:any

  // Tab visibility permissions for Company submenus
  canViewFinancials: boolean = false;  // Only SUPERADMIN can view financials
  canViewContacts: boolean = false;    // SUPERADMIN or contact type access

  constructor
    (private activatedRoute: ActivatedRoute,
      private router: Router,
      private API: ApiService,
      private modalService: BsModalService,
      private location: Location,
      private excelService: ExcelService,
      public util: UtilService,
      public formBuilder: FormBuilder,
      public customerService: CustomerService,
      private pricePlanService: PricePlanService,
      private searchData: SearchData,
      private userService : UserService,
      private companyService: CompanyDataService,
    ) {
    // Determine which navbar list to use based on route context
    this.initializeNavBarList();

    // NOTE: these constructor subscriptions were previously never torn down.
    // ngOnDestroy only removed a body CSS class, so every visit to this
    // (App-Admin / User Management) screen left TWO live router.events
    // listeners behind. Each leaked instance kept running its NavigationStart
    // handler on every navigation app-wide -- including /business/employee and
    // /business/follower, where selectedItem ("employee"/"follower") isn't in
    // getManageSlotName(), producing the repeated `manage button : undefined`
    // warning and accumulating redundant work that made the business menus
    // flaky the longer a session ran. Capture them and unsubscribe on destroy.
    this.subscriptions.add(this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.url;
        // Update navbar list on navigation
        this.initializeNavBarList();
      }
    }));

    // when user refresh this will trigger
    const data = this.location.path().split("?")[0];
    if (data) {
      this.selectedItem = data.split("/")[data.split("/").length - 1] as CUSTOMER_MENU_ITEMS;
      this.updateMenuHeader(this.selectedItem);
      this.manageButton = this.getManageSlotName(this.selectedItem);
    }

    this.subscriptions.add(this.router.events.subscribe(res => {
      if (res instanceof NavigationStart) {
        const data = res.url.split("?")[0];
        if (data) {
          this.selectedItem = data.split("/")[data.split("/").length - 1] as CUSTOMER_MENU_ITEMS;
          this.updateMenuHeader(this.selectedItem);
          this.manageButton = this.getManageSlotName(this.selectedItem);
          this.filterContext = this.updateFilterScreen();
        }
      }
    }));

    this.subscriptions.add(this.activatedRoute.data.subscribe((res: any) => {
      this.businessData = res?.data;
      this.MemberShipType = this.businessData?.plan;
      this.role = this.businessData?.role;

      // Check tab access permissions for Company submenus
      this.checkCompanyTabAccess();
    }));

    this.USERID = localStorage.getItem('userId');
    this.filterContext = this.updateFilterScreen();
  }


  currentRoute: string;
  isStandaloneMode: boolean = false;
  // Undo function for the standalone-mode route-reuse override; null when not active.
  private restoreRouteReuse: (() => void) | null = null;

  // Determine which navbar list to use based on current route
  initializeNavBarList(): void {
    const currentPath = this.location.path().split("?")[0];
    // Check if we're in standalone Job Center, Talent Center, or Talent Pools mode.
    // `/applicants` kept here for legacy-redirect safety — the router resolves
    // it to `/talent-pools` but the transition may briefly hit this check.
    this.isStandaloneMode = currentPath.startsWith('/job-center') ||
                            currentPath.startsWith('/talent-center') ||
                            currentPath.startsWith('/talent-pools') ||
                            currentPath.startsWith('/applicants');

    if (this.isStandaloneMode) {
      this.navBarList = this.standaloneNavBarList;
      // Disable body scroll for standalone screens
      document.body.classList.add('no-body-scroll');
      // Same-URL menu re-clicks on Job Center / Talent Center / Talent Pools
      // must reload the destination. Default router behaviour ignores them.
      // Scoped to this component's lifetime: the pristine strategy is captured
      // once and put back in ngOnDestroy. Previously this override was never
      // undone, so after visiting any of these screens every navigation in the
      // app rebuilt the whole layout (e.g. the business page's Employees /
      // Followers arrows stopped expanding because their menu was recreated
      // mid-click).
      if (!this.restoreRouteReuse) {
        const strategy = this.router.routeReuseStrategy;
        const savedShouldReuse = strategy.shouldReuseRoute;
        const savedOnSameUrl = this.router.onSameUrlNavigation;
        this.restoreRouteReuse = () => {
          strategy.shouldReuseRoute = savedShouldReuse;
          this.router.onSameUrlNavigation = savedOnSameUrl;
          this.restoreRouteReuse = null;
        };
        strategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
      }
    } else {
      this.navBarList = this.fullNavBarList;
      // Ensure body scroll is enabled for other screens
      document.body.classList.remove('no-body-scroll');
    }
  }

  ngOnDestroy(): void {
    // Clean up: restore body scroll when leaving the component
    document.body.classList.remove('no-body-scroll');
    // Tear down the constructor router/data subscriptions so dead instances
    // stop reacting to app-wide navigation (was the source of the leak).
    this.subscriptions.unsubscribe();
    // Put the router's route-reuse behaviour back for the rest of the app.
    if (this.restoreRouteReuse) {
      this.restoreRouteReuse();
    }
  }

  isActiveroute(path: string): boolean {
    return this.router.url.startsWith(path);
  }
  ngOnInit(): void {
    this.currentRoute = this.router.url;
    this.addUserForm();
    this.searchData.setHighlighter('admin');
    this.selectedIndex = 1;
    const email = localStorage.getItem('userName');
    this.USER_PLAN_DETAILS();

    // Fetch GSSID from API if not in localStorage
    if (!this.userGigsumoId && this.userId) {
      this.fetchUserGigsumoId();
    }
  }

  /**
   * Fetches the user's GSSID (gigsumoNo) from the API if not available in localStorage
   */
  private fetchUserGigsumoId(): void {
    this.API.query(`user/${this.userId}`).subscribe({
      next: (res: any) => {
        if (res && res.code === GigsumoConstants.SUCESSCODE && res.gigsumoNo) {
          this.userGigsumoId = res.gigsumoNo;
          localStorage.setItem('GSSID', res.gigsumoNo);
        }
      },
      error: (err) => {
        console.error('Error fetching user GSSID:', err);
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.skipTransition = false, 0);
  }

  canShowMenu(menuItem: any): boolean {
    const { role: userRole, businessData } = this;
    const userId = localStorage.getItem('userId');
    const isOwner = businessData?.businessOwner === userId;

    const superAdminMenus = ["businessJob", "businessCandidate", "businessApplicants"];
    const restrictedForEmployees = ["businessContacts", "contacts"];

    if (superAdminMenus.includes(menuItem.item)){
      return userRole === 'SUPERADMIN' || isOwner;
    }

    if (restrictedForEmployees.includes(menuItem.item)) {
      return userRole !== 'EMPLOYEE';
    }
    return true;
  }




  checkHigherPlanFeatures() {
    // Positive allowlist (fails closed): only paid plans get Create/Manage.
    // The previous negative check (`MemberShipType !== FREE_PLAN`) returned true
    // for `undefined`, so Free users without a business (resolver yields no
    // plan/role) wrongly saw the Create/Manage buttons.
    return [GigsumoConstants.StarterPlan, GigsumoConstants.GrowthPlan, GigsumoConstants.ScaleXPlan]
             .includes(this.MemberShipType) &&
           this.role !== "EMPLOYEE" && this.role !== "ADMIN";
  }

  get isFreeOrTeam(){
    return this.MemberShipType === GigsumoConstants.FREE_PLAN;
  }

  checkDowngradeOrUpgradeOptions() {
    return ( this.MemberShipType !== GigsumoConstants.FREE_PLAN &&
      this.role !== "EMPLOYEE" && this.role !== "ADMIN") || this.role === undefined;
  }


  openContactSales() {
    Swal.fire({
      title: 'Contact Support',
      icon: 'info',
      text: `To downgrade ${this.MemberShipType} plan, please contact the support team.`,
      showConfirmButton: true,
      confirmButtonColor: 'green',
      allowOutsideClick: false
    })
  }

  checkEnterprisePlan():boolean {
     return (this.MemberShipType === GigsumoConstants.ScaleXPlan &&  this.role !== "EMPLOYEE" && this.role !== "ADMIN" )? true : false;
  }

  updateFilterScreen() : Array<any> {
    switch (this.selectedItem) {
      case 'user':
        case 'interaction':
        case 'jobs':
        // this.filterData.enabled = false;
        return [
          {
            label: 'Role',
            payload : 'role',
            options: [
              { value: 'FREELANCE_RECRUITER', label: 'Freelance Recruiter' },
              { value: 'MANAGEMENT_TALENT_ACQUISITION', label: 'Management Talent Acquisition' },
              { value: 'BENCH_RECRUITER', label: 'Bench Sales Recruiter' },
              { value: 'RECRUITER', label: 'Recruiter' },
            ],
          },
          {
            label: 'Status',
            payload : 'status',
            options: [
              { value: 'ACTIVE', label: 'Active' },
              { value: 'INACTIVE', label: 'Inactive' },
              { value: 'INITIATED', label: 'Initiated' },
              { value: 'BLOCKED', label: 'Blocked' },
            ],
          },
          {
            label: 'App Access',
            payload : 'enabled',
            options: [
              { value: 'true', label: 'On' },
              { value: 'false', label: 'Off' },
            ],
          },
          // {
          //   label: 'App Access',
          //   payload : 'enabled',
          //   showTogglebar : true ,
          // }
        ]
        break;

      default:
        return [
          {
            label: 'Status',
            payload : 'status',
            options: [
              { value: 'ACTIVE', label: 'Active' },
              { value: 'INACTIVE', label: 'Inactive' },
            ],
          }
        ]
    }

  }




  switchTab(modules) {

  }


  selectItem(item: any) {
    this.selectedItem = item.item;
    this.selectedName = item.name;
  }
  menuActive = [
    { item: "plan", name: "Plan", },
    { item: "user", name: "Users",   },
    { item: "interaction", name: "Interaction Credits",  },
    { item: "jobs", name: "Job/Candidate Slots", },
    { item: "workSpace", name: "Workspaces",   },
    { item: "contacts", name: "Members",  },
    { item: "network", name: "Member Networks",   },
    { item: "businessContacts", name: "Business",   },
    { item: "businessNetworks", name: "Business Networks", },
    { item: "businessJob", name: "Business Jobs",   },
    { item: "businessCandidate", name: "Business Candidates", },
    { item: "businessApplicants", name: "Business Applicants",  }
  ];
  isActive(item: any): boolean {
    const currentPath = this.location.path().split("?")[0];

    // If item has activeRoutes array, check against all of them
    if (item?.activeRoutes && item.activeRoutes.length > 0) {
      return item.activeRoutes.some((route: string) => currentPath.startsWith(route));
    }

    // Fallback to checking just the path
    return currentPath.startsWith(item?.path || item);
  }

  // Toggle expandable menu items (Company menu)
  toggleExpand(item: any, event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    if (item.isExpandable) {
      item.isExpanded = !item.isExpanded;
      // Navigate to first child when expanding
      if (item.isExpanded && item.children?.length > 0) {
        this.router.navigate([item.children[0].path], {
          queryParams: this.isFreeOrTeam ? this.businessData : null
        });
      }
    }
  }

  // Check if item can be edited (for Company module access control)
  canEditCompanyData(): boolean {
    const userId = localStorage.getItem('userId');
    const isOwner = this.businessData?.businessOwner === userId;
    return this.role === 'SUPERADMIN' || isOwner;
  }

  /**
   * Check user permissions for viewing Financials and Contacts tabs.
   * - Financials: SUPERADMIN only
   * - Contacts: SUPERADMIN or user is listed as Contracts Manager/Signing Authority
   */
  private checkCompanyTabAccess(): void {
    const isSuperAdmin = this.role === 'SUPERADMIN';
    const userId = localStorage.getItem('userId');
    const isOwner = this.businessData?.businessOwner === userId;

    // Financials: SUPERADMIN only
    this.canViewFinancials = isSuperAdmin;

    // Contacts: SUPERADMIN or owner has full access
    if (isSuperAdmin || isOwner) {
      this.canViewContacts = true;
    } else {
      // Check if user is listed as a Contracts Manager or Signing Authority contact
      this.checkContactsAccess();
    }
  }

  /**
   * Check if the current user has access to the Contacts tab based on being
   * listed as a Contracts Manager or Signing Authority contact.
   */
  private checkContactsAccess(): void {
    const businessId = this.businessData?.id || this.businessData?.businessId;
    if (!businessId) {
      this.canViewContacts = false;
      return;
    }

    const userEmail = localStorage.getItem('userName'); // Email is often stored as userName

    this.companyService.getCompanyContacts(businessId).subscribe({
      next: (res) => {
        const contacts = res?.data?.contacts || [];

        // Check if current user is listed as a contact with allowed types
        const allowedContactTypes = ['Contracts Manager', 'Signing Authority'];
        const userContact = contacts.find((c: any) =>
          c.email && userEmail && c.email.toLowerCase() === userEmail.toLowerCase()
        );

        if (userContact && allowedContactTypes.includes(userContact.contactType)) {
          this.canViewContacts = true;
        } else {
          this.canViewContacts = false;
        }
      },
      error: (err) => {
        console.error('Error checking contacts access:', err);
        this.canViewContacts = false;
      }
    });
  }

  /**
   * Returns the company submenus that should be visible based on user permissions.
   * Financials and Contacts tabs are restricted based on access rules.
   */
  get visibleCompanySubMenus(): Array<any> {
    return this.companySubMenus.filter(menu => {
      if (menu.item === 'company-financials') {
        return this.canViewFinancials;
      }
      if (menu.item === 'company-contacts') {
        return this.canViewContacts;
      }
      // Profile, Services, Portfolio are always visible
      return true;
    });
  }

  // Company horizontal sub-menu items
  companySubMenus: Array<any> = [
    { item: "company-profile", name: "Profile", path: '/user-management/company/profile' },
    { item: "company-services", name: "Services", path: '/user-management/company/services' },
    { item: "company-portfolio", name: "Portfolio", path: '/user-management/company/portfolio' },
    { item: "company-contacts", name: "Contacts", path: '/user-management/company/contact-persons' },
    { item: "company-financials", name: "Financials", path: '/user-management/company/financials' }
    // Commented out - moved to Contract Center module
    // { item: "company-customer-docs", name: "Customer Docs", path: '/user-management/company/customer-docs' },
    // { item: "company-supplier-docs", name: "Supplier Docs", path: '/user-management/company/supplier-docs' },
    // { item: "company-agreements", name: "Agreements", path: '/user-management/company/agreements' }
  ];

  // Check if currently viewing a Company route
  isCompanyRoute(): boolean {
    const currentPath = this.location.path().split("?")[0];
    return currentPath.startsWith('/user-management/company');
  }

  // Check if a company sub-menu is active
  isCompanySubMenuActive(subMenu: any): boolean {
    const currentPath = this.location.path().split("?")[0];
    return currentPath === subMenu.path || currentPath.startsWith(subMenu.path);
  }
    // isActive(route: string): boolean {
  //   return this.currentRoute === route;
  // }


  businessName: string;
  bid: string;
  activeScreen: string = "";
  updateMenuHeader(data: string) {


    if (data === "plan" || data === 'billing' || data === 'analytics') {
      this.activeScreen = "TOPUP";
    } else if (data === 'user') {
      this.activeScreen = "USER";
    } else if (data === 'businessNetworks') {
      this.activeScreen = "B2BNETWORKS";
    }  else if (data === 'businessContacts') {
      this.activeScreen = "B2BCONTACTS";
    }else if (data === 'contacts') {
      this.activeScreen = "CONTACT";
    } else if (data === 'network') {
      this.activeScreen = "NETWORK";
    } else if (data === 'workSpace') {
      this.activeScreen = "WORKSPACE"
    }else if (data === 'business-jobs') {
      this.activeScreen = "BUSINESS-JOBS"
    }else if (data === 'business-candidates') {
      this.activeScreen = "BUSINESS-CANDIDATES"
    }else if (data === 'business-applicants') {
      this.activeScreen = "BUSINESS-APPLICANTS"
    } else if (data === 'publishSettings') {
      this.activeScreen = "PUBLISH-SETTINGS"
    } else {
      this.activeScreen = "SLOT"
    }
    // console.log(data)
    this.showNavbar()
  }
  addUserForm() {

  }


  openModal(content) {
    this.modalService.show(content, { backdrop: 'static', keyboard: false, class: 'modal-lg', ignoreBackdropClick: true });
  }


  getManageSlotName(d) {
    switch (d) {
      case "jobs":
        return 'Manage Slots'
        break;
      case "interaction":
        return 'Manage Interactions'
        break;
      case "user":
        return 'Manage Users'
        break;
      case "workSpace":
        return 'Workspace Allocations'
        break;
      case "network":
        return 'Manage Networks'
        break;
      case "contacts":
        return 'Manage Members'
        break;
      case "businessContacts":
        return 'Manage Business'
        break;
      case "businessNetworks":
        return 'Manage Business Networks'
        break;
      default:
        break;
    }
  }
  bsModalRef: BsModalRef;
  slotFields = [];
  slotTitle : string = "";
  slotUserData = [];
  slotPlanDetails = {};
  SLOTKEY :BENEFITS_KEY;
  slotModalOpen = false;
  @ViewChild("manageUserModal", { static: true }) manageUserModalTemplate: TemplateRef<any>;
  async openModalUsingComponent(button: string, multiple = true) {
      this.util.startLoader();

      const trimmedButton = button.trim();

      const buttonToUrlMap: { [key: string]: string } = {
          "Manage Users": "user/userDetails",
          "Manage Members": "contacts/contactDetails",
          "Manage Business": "businessContacts/managebusiness",
          "Manage Business Networks": "businessNetworks/managebusinessnetwork",
          "Manage Workspaces": "workSpace/manageWorkspace",
          "Manage Networks": "network/manageNetwork",
      };

      if (trimmedButton in buttonToUrlMap) {
          const URL = buttonToUrlMap[trimmedButton];
          // console.log("URL IS HERE" , URL);

          setTimeout(() => {
              this.router.navigate(['/user-management/' + URL], { queryParams: this.businessData });
              this.util.stopLoader();
          }, 300);
          return;
      }



      let planData = await this.getBUsinessPLanBenefits();
      const KEY = this.selectedItem === "interaction" ? "ACTIVE_INTERACTIONS" :
      this.selectedItem === 'jobs' ? "JOB_CANDIDATE_POSTINGS" :
      this.selectedItem === 'contacts' ? "INCLUDED_CONVERSATIONS" :
      this.selectedItem === 'network' ? 'PERSONAL_NETWORKS' :
      button === "Manage User" ? "USERS" :
      "TEAM_WORKSPACES"  as BENEFITS_KEY;
      this.customerService.openSlotModals({value : planData , key : this.selectedItem});


      this.util.stopLoader();
  }

  getFieldsForManageAll(): Array<Partial<TEXT_FIELDS>> {
    switch (this.selectedItem) {
      case "contacts":
        return [
          { label: "UID", key: 'gigsumoNo' },
          { label: "Name", key: 'fullName' },
          { label: "Email", key: 'email' },
          { label: "Role", key: 'userType' },
          { label: "Contact Type", key: 'contactType' },
          { label: "Organization Name", key: 'organisation' },
          { label: "Organization Type", key: 'clientType' },
        ];
        case "businessContacts":
        return [
          { label: "Business name", key: 'gigsumoNo' },
          { label: "Owner", key: 'fullName' },
          { label: "Email", key: 'email' },
          { label: "Role", key: 'userType' },
          { label: "Business Type", key: 'contactType' },
          { label: "Network", key: 'organisation' },

        ];
      case 'network':
        return [
          { label: 'Network Name', key: 'businessNetworkName' },
          { label: 'Owner', key: 'owner' },
          { label: 'Email', key: 'email' },
          { label: 'Role', key: 'role' },
          { label: 'Members', key: 'membersCount' },
        ]
        case 'businessNetworks':
          return [
            { label: 'Network name', key: 'businessNetworkName' },
            { label: 'Owner', key: 'owner' },
            { label: 'Email', key: 'email' },
            { label: 'Role', key: 'role' },
            { label: 'Members', key: 'membersCount' },
          ]
      case 'workSpace':
        return [
            { label: 'Workspace name', key: 'teamName' },
            { label: 'Owner', key: 'owner' },
            { label: 'Members', key: 'memberCnt' },
          ]
      case 'user':
        return [
            { label: 'Name', key: 'fullName' },
            { label: 'Email', key: 'email' },
            { label: 'Role', key: 'userType' },
          ]
    }
  }


  getFieldsForManageWorkspace(): Array<Partial<TEXT_FIELDS>> {
    return [
      { label: 'Workspace name', key: 'teamName' },
      { label: 'Owner', key: 'owner' },
      { label: 'Members', key: 'memberCnt' },
    ]
  }

  async openAddUserModal() {
    this.util.startLoader();
    setTimeout(() => {
      // Extra class on .modal-dialog for the Role ng-select's
      // appendTo=".gs-add-user-modal" (see customer.component.ts) — per-call
      // spread so the shared MODAL_OPTIONS stays untouched.
      this.bsModalRef = this.modalService.show(AddUserComponent, { ...MODAL_OPTIONS, class: 'modal-lg gs-add-user-modal' });
      this.util.stopLoader();
    }, 200);
  }

  async getBUsinessPLanBenefits() {
    const userPlan: any = await this.API.lamdaFunctionsget('findBusinessPlanBenefits/' + this.businessData.id);
    return userPlan.data != null ? userPlan.data.businessPlanAndBenefits : null;
  }

  benefitdetails: any
  async openModalContact() {
    this.util.startLoader();

    const plan = await this.getBUsinessPLanBenefits();
    if(plan){
      const planData = plan.benefitsUsages.find(x => x.benefitKey === this.getBenefitKeys());
      // console.log("business plan" , planData);

      setTimeout(() => {
          this.util.stopLoader();

          if (planData && planData.available > 0) {
            this.showModal = true;
            this.openbusinessModal = true;
          } else if (planData && planData.available == 0) {
            this.showModal = false;
            this.planvalidationpopup(planData, this.selectedItem);
          }

      }, 500);

    }


  }


  getBenefitKeys() : string  {
    return this.selectedItem === "contacts" ? "INCLUDED_CONVERSATIONS" :
    this.selectedItem === "businessNetworks" ? "B2B_NETWORKS" :
    this.selectedItem === "businessContacts" ? "B2B_CONTACTS" :
    this.selectedItem === "network" ? "PERSONAL_NETWORKS" : "";
  }
  //paln validation popups for business,contacts and networks creation by monisha
  planvalidationpopup(plan, selecteditem) {
    this.util.startLoader();
    let benefitkey;
    if (selecteditem === "network") {
      benefitkey = 'PERSONAL_NETWORKS';
    } else if (selecteditem === "contacts") {
      benefitkey = 'INCLUDED_CONVERSATIONS';
    } else if (selecteditem === "businessContacts")
      benefitkey = 'B2B_CONTACTS';
    else if (selecteditem === "businessNetworks")
        benefitkey = 'B2B_NETWORKS';
    this.pricePlanService.expiredPopup(
      benefitkey,
      "PAY",
      null,
      null,
      null,
      null,
      plan.available,
      plan.actual,
      plan.utilized,
      plan.promotional
    );

    this.util.stopLoader();
  }


  closeModal(data?) {
    this.showModal = false;
    // this.modalService.hide(this.modalService.getModalsCount());
  }

  payload = {
    businessId: null,
    email: null,
    limit: 0,
    page: 0,

  }
  getCustomerUsersList(): Observable<any> {
    return this.API.create('subscription/findEmployeeBenefitsAllocation', this.payload);
  }



  isChildActive(parentRoute: string): boolean {
    return this.currentRoute.startsWith(parentRoute);
  }

//excel function for all admin modules by monisha
  downloadExcel() {
    this.payload.businessId = this.businessData.businessId;
    this.payload.limit = this.excelService.getTotalCount();

    this.getCustomerUsersList().subscribe(res => {

      if (res.code === GigsumoConstants.SUCESSCODE) {
        let headers = this.getHeaders();
        let arr = res.data.customerUserAllocationList;

        if (arr) {
          this.excelService.downloadExcel(arr, headers, this.selectedItem);
        }
      }
    });

  }

//table heading and table data passed in excels.
  getHeaders() {
    switch (this.selectedItem) {
      case "user":
        return [
          { header: "User", key: "fullName" },
          { header: "Email ID", key: "username" },
          { header: "Gigsumo ID", key: "gigsumoNo" },
          { header: "Role", key: "userType" },
          { header: "App Access", key: "memberShipType" },
          { header: "Start Date", key: "userCount" },
          { header: "Last Active", key: "createdOn" },
          { header: "Status", key: "userStatus" },
        ];
        break;
      case "interaction": case "jobs": case "workSpace":
        return [
          { header: "User", key: "fullName" },
          { header: "Email ID", key: "username" },
          { header: "Gigsumo ID", key: "gigsumoNo" },
          { header: "Role", key: "userType" },
          { header: "Allocated", key: "memberShipType" },
          { header: "Available", key: "userCount" },
          { header: "Start Date", key: "createdOn" },
          { header: "Last Active", key: "activity" },
          { header: "Status", key: "userStatus" },
        ];
      case "network":
        return [
          { header: "Network", key: "businessName" },
          { header: "Contacts", key: "adminId" },
          { header: "Owner", key: "phone" },
          { header: "Role", key: "businessType" },
          { header: "Create Date", key: "memberShipType" },
          { header: "Allocated", key: "memberShipType" },
          { header: "Available", key: "userCount" },
          { header: "Last Active", key: "createdOn" },
          { header: "Status", key: "userStatus" },
        ];
      case "contacts":
        return [
          { header: "User", key: "businessName" },
          { header: "Email ID", key: "username" },
          { header: "Role", key: "userType" },
          { header: "Company", key: "memberShipType" },
          { header: "Company Type", key: "userCount" },
          { header: "Network", key: "createdOn" },
          { header: "Partner since", key: "activity" },
          { header: "Last Active", key: "userStatus" },
          { header: "Status", key: "status" },
        ];
      default:
        break;
    }

  }

  selectedIndex: number = 0;
  selectedTabName: any = "Jobs";
  selectTab(tabChangeEvent: MatTabChangeEvent): void {
    this.selectedTabName = tabChangeEvent.tab.textLabel;
  }

  searchText : string  = '';
  routeTo(item) {
    this.selectedItem = item;
    this.filterData = {};
    this.searchText = '';
  }

  showChevron: boolean = false;
  showChevron1: boolean = false;
  scrollLeft() {
    const scrollContainer = document.getElementById('scrollContainer1');
    scrollContainer.scrollLeft -= 1000; // Adjust the scroll amount as needed
  }

  scrollRight() {
    const scrollContainer = document.getElementById('scrollContainer1');
    scrollContainer.scrollLeft += 1000; // Adjust the scroll amount as needed
  }

  onMouseEnter() {
    this.showChevron = true;
  }

  onMouseLeave() {
    this.showChevron = false;
  }

  onMouseEnter1() {
    this.showChevron1 = true;
  }

  onMouseLeave1() {
    this.showChevron1 = false;
  }
  pageName: any;
  pageNamevalues(b): void {
    this.util.startLoader();
    if (b == '/newjobs/job-applic') {
      this.pageName = 'job-applicants'
    } else if (b == '/newjobs/job-detail') {
      this.pageName = 'job-details'
    } else if (b == '/newjobs/jobs-viewe') {
      this.pageName = 'jobs-viewed'
    } else if (b == '/newjobs/job-reques') {
      this.pageName = 'job-requests-received'
    } else if (b == '/newjobs/jobs-liked') {
      this.pageName = 'jobs-liked'
    } else if (b == '/newjobs/jobs-invit') {
      this.pageName = 'jobs-invitedlist'
    } else if (b == '/newjobs/candidates') {
      this.pageName = 'candidates-invited'
    }
    else if (b == '/newjobs/job-applicants') {
      this.pageName = 'job-filter'
    } else if (b == '/newjobs/candi-filt') {
      this.pageName = 'candi-filter'
    } else if (b == '/newjobs/job-applic') {
      this.pageName = 'candidate-applied'
    }
    this.util.stopLoader();
  }

  manageUsers() {
    const userDetails = this.userData;
    if (userDetails) {
      const onlyEditedData = userDetails.reduce((prev: any, curr: any, index: number) => {
        if (curr.appAccessEnabled != this.tempUserData[index].appAccessEnabled) {
          prev.push(curr);
        }
        return prev;
      }, []);


      this.API.create('user/manageUsers', onlyEditedData).subscribe(response => {
        if (response.code === GigsumoConstants.SUCESSCODE) {
          Swal.fire({
            icon: "success",
            title: "Users Updated",
            text: "Users updated successfully",
            showConfirmButton: false,
            timer: 2000,
          });
          this.closeModal();
          this.customerService.emitRefresh("user");
        }
      });


    }

  }


  onActivate(data) {

    if (data && data.activate) {

      data.activate.subscribe(res => {
        if (res) {
          this.openModalUsingComponent(res, false);
        }
      });

    }

  }

  componentRemoved(data) {

    if (data && data.activate) {
      data.activate.unsubscribe();
    }

  }

  showSearchBar() : boolean {
    // In standalone mode, always show the header
    if (this.isStandaloneMode) {
      return true;
    }
    // let termsArray = ["plan", "user", "interaction", "jobs", "workSpace", "businessNetworks", "businessContacts", "network", "contacts", "analytics", "billing", "business-jobs", "business-candidates", "business-applicants"];
    let termsArray = ["plan", "user", "interaction", "jobs", "workSpace","business-jobs","business-candidates", "businessNetworks", "businessContacts", "network", "contacts", "analytics", "publishSettings"];
    return termsArray.includes(this.selectedItem);
  }

  /**
   * Check if business data has meaningful values (businessName, bid, or plan)
   * Returns true if any business-specific data exists
   */
  hasBusinessData(): boolean {
    return !!(this.businessData?.businessName || this.businessData?.bid || this.businessData?.plan);
  }

  showNavbar(): boolean {
    // In standalone mode, hide the horizontal nav menu (admin-hor-menu)
    if (this.isStandaloneMode) {
      return false;
    }
    let navArray = ["plan", "user", "interaction", "jobs","business-jobs","business-candidates", "workSpace", "businessNetworks", "businessContacts", "network", "contacts", "analytics", "publishSettings"]
    return navArray.includes(this.selectedItem);
  }


  saveFilter(){
    this.customerService.emitFilter({
      value: this.filterData,
      key: this.selectedItem
    });
  }

  onSearch() {
    this.customerService.emitSearch({
      value: this.searchText,
      key: this.selectedItem
    });
  }


  onClose(d){
    if(d === "CLOSE"){
      this.slotModalOpen = false;
    }
  }

  onScroll(){

  }



  // Membership code added here and code get from membership component  we can cancel current plan

  // get active candidate
  findActiveCandidates: any;
  findActiveCandidatesSub: Subscription;

  candidatesListAPI() {

    let data: any = { "userId": localStorage.getItem('userId'), "limit": 1000, "searchAfterKey": null }
    this.findActiveCandidatesSub = this.API.create('candidates/findActiveCandidates', data).subscribe(res => {
      this.findActiveCandidates = res.data.candidateList;
      this.util.stopLoader();
      this.findActiveCandidates.forEach((obj) => {
        obj.isSelected = false;
      });
    })
  }


  // get active jobs
  findActiveJobsSub: Subscription;
  findActiveJobs: any;
  JobListAPI() {

    let data: any = { "userId": localStorage.getItem('userId'), "limit": 1000, "searchAfterKey": null }
    this.findActiveJobsSub = this.API.create('jobs/findActiveJobs', data).subscribe(res => {
      this.findActiveJobs = res.data.jobList;
      this.util.stopLoader();
      this.findActiveJobs.forEach((obj) => {
        obj.isSelected = false;
      });
    })
  }



  // get teams

  findteamListSub: Subscription;
  findteamList:any=[];

  TeamListAPI() {

    let data: any = { "userId": localStorage.getItem('userId') }
    this.findteamListSub = this.API.query('teams/findActiveTeams/' + data.userId).subscribe(res => {
      this.util.stopLoader();
       this.findteamList=[];
      res.data.activeTeams.forEach(element => {
        // if(element.memberType=='OWNER'){
          element.isSelected=false;
          this.findteamList.push(element);
        // }
      });
    })
  }

  backdropConfig = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
    class:'modal-lg'
  };

  openList = false;
  modalRef: BsModalRef;
  dontselectJob=false;
  plan(template: TemplateRef<any>) {

    this.USER_PLAN_DETAILS();
    this.JobListAPI();
    this.candidatesListAPI();
    this.TeamListAPI();

    let counts=(this.findActiveCandidates.length+this.findActiveJobs.length);

    if(this.findteamList.length <=1 && counts<6 ){
      this.dontselectJob=true;
      this.submit();
    }else{
      this.modalRef = this.modalService.show(template, this.backdropConfig);
    }



  }

  activejobcount: number = 0;
  activeCandidatesCount: number = 0;
  totalCount: number = 0;
  downgradeRequested:boolean=false;

  planCount: any = {
    benefitsUsages: [
      { utilized: 0 },
      { utilized: 0 },
      { utilized: 0 },
      { actual: 0 }
    ]
  };
  async USER_PLAN_DETAILS() {

    let planbenefits: any = await this.API.lamdaFunctionsget('findUserPlanBenefits/' + localStorage.getItem('userId'));
    if (planbenefits.data != undefined && this.userType != "JOB_SEEKER") {
      this.util.stopLoader();
      this.activejobcount = planbenefits.data.activeJobsCount != undefined ? planbenefits.data.activeJobsCount : 0;
      this.activeCandidatesCount = planbenefits.data.activeCandidatesCount != undefined ? planbenefits.data.activeCandidatesCount : 0;
      this.totalCount = this.activeCandidatesCount + this.activejobcount;
       if (planbenefits.data.userPlanAndBenefits) {
        this.planCount.benefitsUsages = [];
        this.planCount.benefitsUsages = planbenefits.data.userPlanAndBenefits.benefitsUsages;
      }
       this.userService.updateUserPlanDetails(planbenefits.data.userPlanAndBenefits);
       localStorage.setItem("MemberShipType", planbenefits.data.userPlanAndBenefits.membershipType);
       // Update userPlan for display when no business exists
       this.userPlan = planbenefits.data.userPlanAndBenefits.membershipType || 'Free';
       if(planbenefits.data.userPlanAndBenefits?.downgradeRequested!=undefined && planbenefits.data.userPlanAndBenefits?.downgradeRequested){
        this.downgradeRequested=true;
      }else{
        this.downgradeRequested=false;
      }
    }

  }

  selectedCandidatedtoremove: any = [];
  seletedCandidateCount:any=[];
  getseletedCandidate(data: any) {
    this.seletedCandidateCount=[]
    this.updateCount(this.seletedCandidateCount.length , this.selectedjobscount.length);
    this.findActiveCandidates.forEach(obj => {
      if (data.value === obj.candidateId && data.flag === 'true') {
        obj.isSelected = true;
        this.seletedCandidateCount= this.findActiveCandidates.filter(obj => obj.isSelected === true);
        this.updateCount(this.seletedCandidateCount.length , this.selectedjobscount.length);

        // console.log(this.seletedCandidateCount)
      } else if (data.value === obj.candidateId && data.flag === 'false') {
        obj.isSelected = false;
      }
    });
  }
  selectedjobscount:any=[];
  getseletedjobs(data: any) {
    this.selectedjobscount=[]
    this.updateCount(this.seletedCandidateCount.length , this.selectedjobscount.length);
    this.findActiveJobs.forEach(obj => {
      if (data.value === obj.jobId && data.flag === 'true') {
        obj.isSelected = true;
        this.selectedjobscount= this.findActiveJobs.filter(obj => obj.isSelected === true);
        this.updateCount(this.seletedCandidateCount.length , this.selectedjobscount.length);

        // console.log(this.selectedjobscount)
      } else if (data.value === obj.jobId && data.flag === 'false') {
        obj.isSelected = false;
      }
    });
  }


  seletedTeamCount=[];
  count:any=[];
  getseletedTeams(data:any){

    this.updateCount(this.seletedCandidateCount.length , this.selectedjobscount.length);
    this.findteamList.forEach(obj => {
      if (data.value === obj.teamId && data.flag === 'true') {
        obj.isSelected = true;
        this.seletedTeamCount= this.findteamList.filter(obj => obj.isSelected === true);
        this.updateCount(this.seletedCandidateCount.length , this.selectedjobscount.length);

      } else if (data.value === obj.teamId && data.flag === 'false') {
        obj.isSelected = false;
      }
    });


  }


  teamvalidation = false;
  updateCount(one: number, two: number) {
    this.count = (one || 0) + (two || 0);
  }

  submit() {
    Swal.fire({
      title: "Are you sure want to downgrade the plan?",
      showDenyButton: true,
      confirmButtonText: "Yes",
      denyButtonText: `No`,
      allowOutsideClick: false
    }).then((result) => {
       if (result.isConfirmed) {
         this.apiDowngrade();
      } else if (result.isDenied) {
       }
    });

  }

  apiCancelDowngrade(){
    const userId = localStorage.getItem('userId');
    this.util.startLoader();
    this.findActiveJobsSub = this.API.create('user/cancelDowngradeRequest/'+userId,{}).subscribe(res=>{
      this.util.stopLoader();
      if(res.code==="00000"){
         Swal.fire({
            icon: "success",
            title: "Downgrade Cancelled Successfully",
            timer: 2000,
          });
          setTimeout(() => {
            this.router.navigate(["landingPage"]);
            this.searchData.setHighlighter('landingPage');
          }, 1000);
      }
    })
  }

  requestDowngrade() {
    Swal.fire({
      icon: 'question',
      title: "Plan Downgrade",
      text: `Are you sure you want to downgrade from ${this.MemberShipType} plan?`,
      confirmButtonText: 'Yes',
      showCancelButton: true,
      cancelButtonText: 'No',
      allowOutsideClick: false,
      allowEscapeKey: false
     }).then((result) => {
      if (result.isConfirmed) {
        this.apiDowngrade();
      }
    });
  }

  apiDowngrade(){
    const userId = localStorage.getItem('userId');
    const data = { userId, teamsToBeDeactivated: null, jobsToBeDeactivated: null, candiatesToBeDeactivated: null };
    this.util.startLoader();
    this.findActiveJobsSub = this.API.create('user/requestForPlanDowngrade/'+userId,{}).subscribe(
      res => {
        this.findActiveJobs = res.data;
        this.util.stopLoader();
        this.dontselectJob = false;
        this.modalService.hide(1);
         if(res.code==="00000"){
          // this.gigsumoService.planUpdatedTo = 'Free';
            const date = new Date(res.data.planUsageHistory.toDate);
            const formattedDate = new Intl.DateTimeFormat('en-US', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            }).format(date);

            Swal.fire({
              icon: 'success',
              title: "Your request for plan downgrade is received",
              text: "Your plan will be downgraded on " + formattedDate + ". You will continue to enjoy the benefits of the current plan until then.",
              confirmButtonText: 'OK',
              allowOutsideClick: false,
              allowEscapeKey: false
             }).then((result) => {
              if (result.isConfirmed) {
                setTimeout(() => {
                  this.downgradeRequested = true;
                  // this.router.navigate(["landingPage"]);
                  // this.searchData.setHighlighter('landingPage');
                }, 1000);
              }
            });
        }else if (res.code==="99998"){
          Swal.fire({
            icon: "info",
            title: "Plan already downgraded",
            timer: 2000
          })

          this.downgradeRequested=true;
        }
      },
      error => {
         this.util.stopLoader();
       }
    );
  }

  /**
   * Toggle sidebar expanded/collapsed state
   * Persists preference in localStorage
   */
  toggleSidebar(): void {
    this.sidebarExpanded = !this.sidebarExpanded;
    localStorage.setItem('customerDetailSidebarExpanded', String(this.sidebarExpanded));
  }
}
